

























import { Vue, Component, Watch } from 'vue-property-decorator';
import jintro2 from './components/jintro2.vue';
import equipMent from './components/equipMent.vue';
import footpannel from './components/fooTer.vue';
import { formRules } from '@/common/util/validator';
import { Public } from '@/http/api_Public';
import jbanner from "./components/jbanner.vue" 
import jintro1 from "./components/jintro1.vue" 
import productmeal from "./components/productmeal.vue" 
@Component({ 
    components: {
        'v-jintro2':jintro2,
        'v-equipment':equipMent,
        'v-footpannel':footpannel,
        'v-banner':jbanner,
        'v-jintro1':jintro1,
        'v-productmeal':productmeal,
    }, 
})
export default class home2 extends Vue {
  
    public $refs!: {
       
    };
    
   
    async mounted() {
        
    }
    async created() {
    }
  
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/home2.vue